export default __webpack_public_path__ + "static/media/info-btcb.50eee219.png";